export default __webpack_public_path__ + "static/media/websword2.47e88d0f.png";